const handleTopPickClickGAEvent = (itemCode) => {
  if (window.ga) {
    ga(
      "send",
      "event",
      "BlackFridayDeals",
      "Homepage Top Picks",
      "Product Click"
    );
    ga(
      "send",
      "event",
      "BlackFridayDeals",
      "Homepage Top Picks",
      `Product ${itemCode}`
    );
  }
};

const handleArrowClick = () => {
  if (window.ga) {
    ga("send", "event", "BlackFridayDeals", "Homepage Top Picks", "Arrow");
  }
};

const handleDotsClick = () => {
  if (window.ga) {
    ga("send", "event", "BlackFridayDeals", "Homepage Top Picks", "Dots");
  }
};

const initialiseEvents = () => {
  $sd(document).on(
    "click",
    "#sliderTarget-homeTopPicksCarousel .topPick",
    function () {
      const itemCode = this.getAttribute("data-item-code");
      handleTopPickClickGAEvent(itemCode);
    }
  );

  $sd(document).on(
    "click",
    "#sliderTarget-homeTopPicksCarousel .slick-prev, #sliderTarget-homeTopPicksCarousel .slick-next",
    function () {
      handleArrowClick();
    }
  );

  $sd(document).on(
    "click",
    "#sliderTarget-homeTopPicksCarousel .slick-dots li",
    function () {
      handleDotsClick();
    }
  );

  $sd("#sliderTarget-homeTopPicksCarousel").on("swipe", function () {
    handleArrowClick();
  });
};

export default initialiseEvents;
